export const HEADER_FONT_SIZE = 14
export const SECTION_HEADER_FONT_SIZE = 12
export const TABLE_HEADERS_FONT_SIZE = 8
export const BODY_FONT_SIZE = 10

export const HEADER_MARGINS = [20, 20, 20, 20]
export const BASIC_MARGINS = [10, 10, 10, 10]
export const SUMMARY_MARGINS = [0, 10, 0, 10]
export const TABLE_HEADERS_MARGIN = [0, 2, 0, 2]
export const TABLE_BODY_MARGIN = [0, 2, 2, 2]

export const LAYOUT_TYPES = {
  NO_BORDER: 'noBorder',
  DEFAULT: 'default',
  SPECIAL: 'special',
  NO_BOTTOM_BORDER: 'noBottomBorder',
  NO_TOP_AND_BOTTOM_BORDER: 'noTopAndBottomBorder',
  NO_TOP_BORDER: 'noTopBorder',
  NO_HEADER_BOTTOM_BORDER: 'noHeaderBottomBorder',
  ROW_ONLY_BORDER_WITHOUT_BOTTOM_BORDER: 'rowOnlyBorderWithoutBottomBorder',
  ROW_ONLY_BORDER_WITH_BOTTOM_BORDER: 'rowOnlyBorderWithBottomBorder'
}

export const getHeaders = (currency = 'EUR') => [
  'Ref',
  'Short Description',
  '% of Contract Amount',
  `Total [${currency}]`,
  `CUMULATIVE To Date [${currency}]`,
  `CUMULATIVE previous [${currency}]`,
  `This Payment [${currency}]`
]

export const HEADERS_KEYS = [
  'ref', 'description', 'percent', 'totalCents', 'cumulativeCents', 'cumulativePreviousCents', 'paymentCents'
]

export const generateLayout = ({
  hLineColorStartEnd = 'black',
  hLineColorMiddle = 'gray',
  hLineWidthStartEnd = 2,
  hLineWidthMiddle = 1,
  paddingTop = 0,
  paddingBottom = 0,
  noTopBorder = false,
  noBottomBorder = false,
  noHeaderBottomBorder = false,
  rowBordersOnly = false
} = {}) => ({
  hLineWidth: (i, node) => {
    if (i === 0 && noTopBorder) return 0
    if (i === node.table.body.length) return noBottomBorder ? 0 : hLineWidthStartEnd
    return hLineWidthMiddle
  },
  hLineColor: (i, node) => {
    if (i === 0 || i === node.table.body.length) return hLineColorStartEnd
    return hLineColorMiddle
  },
  vLineWidth: (i, node) => {
    if (rowBordersOnly) {
      if (i === 0 || i === node.table.widths.length) return 1
      return 0
    }
    return 1
  },
  vLineColor: (i, node) => {
    if (i === 0 || i === node.table.widths.length) return 'black'
    return 'gray'
  },
  paddingTop: () => paddingTop,
  paddingBottom: () => paddingBottom,
  hLineWidthHeader: (i, node) => {
    if (i === 1 && noHeaderBottomBorder) return 0
    return hLineWidthMiddle
  }
})

export const LAYOUTS = {
  [LAYOUT_TYPES.NO_BORDER]: {
    hLineWidth: () => 0,
    vLineWidth: () => 0
  },
  [LAYOUT_TYPES.DEFAULT]: generateLayout({
    hLineColorStartEnd: 'black',
    hLineColorMiddle: 'gray',
    hLineWidthStartEnd: 1,
    hLineWidthMiddle: 1,
    paddingTop: 2,
    paddingBottom: 2,
    noTopBorder: false,
    noBottomBorder: false
  }),
  [LAYOUT_TYPES.SPECIAL]: generateLayout({
    hLineWidthStartEnd: 0,
    hLineWidthMiddle: 1,
    paddingTop: 2,
    paddingBottom: 2
  }),
  [LAYOUT_TYPES.NO_BOTTOM_BORDER]: generateLayout({
    noBottomBorder: true
  }),
  [LAYOUT_TYPES.NO_TOP_AND_BOTTOM_BORDER]: generateLayout({
    noTopBorder: true,
    noBottomBorder: true
  }),
  [LAYOUT_TYPES.NO_TOP_BORDER]: generateLayout({
    noTopBorder: true
  }),
  [LAYOUT_TYPES.NO_HEADER_BOTTOM_BORDER]: generateLayout({
    noHeaderBottomBorder: true
  }),
  [LAYOUT_TYPES.ROW_ONLY_BORDER_WITHOUT_BOTTOM_BORDER]: generateLayout({
    hLineColorStartEnd: 'black',
    hLineColorMiddle: 'gray',
    hLineWidthStartEnd: 1,
    hLineWidthMiddle: 1,
    paddingTop: 2,
    paddingBottom: 2,
    noTopBorder: true,
    noBottomBorder: false,
    rowBordersOnly: true
  }),
  [LAYOUT_TYPES.ROW_ONLY_BORDER_WITH_BOTTOM_BORDER]: generateLayout({
    hLineColorStartEnd: 'black',
    hLineColorMiddle: 'gray',
    hLineWidthStartEnd: 1,
    hLineWidthMiddle: 1,
    paddingTop: 2,
    paddingBottom: 2,
    noTopBorder: true,
    noBottomBorder: false,
    rowBordersOnly: true
  })
}
